import { Button, ButtonsGroup, Checkbox, Flex, Modal, ModalProps, Text, useModal } from '@billy/design-system'
import { ReactElement, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useUpdateOrganizationSettings, useUserOrganization } from '@modules-deprecated/app/organization'

import * as Styled from './styles'

interface ReceiptAutoForwardInfoModalProps extends ModalProps {
  onAccept: () => void
  onDismiss?: () => void
}

export const ReceiptAutoForwardInfoModal = ({
  id,
  onAccept,
  onDismiss,
  ...modalProps
}: ReceiptAutoForwardInfoModalProps): ReactElement => {
  const { t } = useTranslation()
  const { update: updateOrganizationSetting } = useUpdateOrganizationSettings()
  const { organization } = useUserOrganization()
  const [shouldNotShowAgain, setShouldNotShowAgain] = useState(false)
  const organizationId = organization?.id

  const updateShouldNotShowAgain = () => {
    setShouldNotShowAgain(!shouldNotShowAgain)
  }

  const handleCheckboxChange = () => {
    if (!organizationId || !shouldNotShowAgain) {
      return
    }
    updateOrganizationSetting({
      key: 'isAutoForwardInfoModalDismissed',
      organizationId,
      value: '1',
    })
  }

  const { close } = useModal(id, {
    onClose: () => {
      handleCheckboxChange()
      onDismiss?.()
    },
  })

  const handleAcceptClick = () => {
    onAccept()
    close()
  }

  return (
    <Modal id={id} size="s" autofocusOnInput closable {...modalProps}>
      <Modal.Header title={t('auto_forward_enabled_upload_modal.title')} />
      <Modal.Body>
        <Text>{t('auto_forward_enabled_upload_modal.description')}</Text>
      </Modal.Body>
      <Modal.Footer>
        <Styled.FooterContentWrapper>
          <Flex justifyContent="space-between" alignItems="center" flexGrow={1}>
            <Checkbox checked={shouldNotShowAgain} onChange={updateShouldNotShowAgain}>
              <Text>{t('auto_forward_enabled_upload_modal.dont_show_again')}</Text>
            </Checkbox>
            <ButtonsGroup>
              <Button onClick={handleAcceptClick}>{t('auto_forward_enabled_upload_modal.accept')}</Button>
            </ButtonsGroup>
          </Flex>
        </Styled.FooterContentWrapper>
      </Modal.Footer>
    </Modal>
  )
}
